import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/commons/useAuth';
import { PATH } from '@/commons/constants';

/** AuthGuard props */
interface AuthGuardProps {
  /** Content to render when authenticated */
  children: ReactNode;
}

/**
 * Guard that redirects unauthenticated users to the login page.
 * Saves current location in state so the user can be redirected back after login.
 *
 * @param props - AuthGuardProps
 * @returns Navigate to login (with state.from) or children
 */
export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { auth } = useAuth();
  const location = useLocation();

  if (!auth) {
    return <Navigate to={PATH.LOGIN} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
